const BOARD_PALETTE: { name: string; ring: string; bg: string; text: string }[] = [
  { name: "slate",   ring: "ring-slate-400/60",   bg: "bg-slate-500",   text: "text-white" },
  { name: "cyan",    ring: "ring-cyan-400/60",    bg: "bg-cyan-500",    text: "text-white" },
  { name: "teal",    ring: "ring-teal-400/60",    bg: "bg-teal-500",    text: "text-white" },
  { name: "emerald", ring: "ring-emerald-400/60", bg: "bg-emerald-500", text: "text-white" },
  { name: "amber",   ring: "ring-amber-400/60",   bg: "bg-amber-500",   text: "text-white" },
  { name: "rose",    ring: "ring-rose-400/60",    bg: "bg-rose-500",    text: "text-white" },
  { name: "violet",  ring: "ring-violet-400/60",  bg: "bg-violet-500",  text: "text-white" },
  { name: "indigo",  ring: "ring-indigo-400/60",  bg: "bg-indigo-500",  text: "text-white" },
];

export type BoardColor = (typeof BOARD_PALETTE)[number];
export const BOARD_COLOR_NAMES: readonly string[] = BOARD_PALETTE.map(c => c.name);

function djb2(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h) ^ s.charCodeAt(i);
  }
  return h >>> 0;
}

export function getBoardInitials(title: string): string {
  const cleaned = title.trim();
  if (!cleaned) return "?";
  const words = cleaned.split(/\s+/);
  if (words.length === 1) {
    return cleaned.slice(0, 2).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function getBoardColor(title: string, override?: string | null): BoardColor {
  const name = override?.toLowerCase();
  if (name) {
    const match = BOARD_PALETTE.find(c => c.name === name);
    if (match) return match;
  }
  const idx = djb2(title) % BOARD_PALETTE.length;
  return BOARD_PALETTE[idx];
}

export { BOARD_PALETTE };
